// مشترک صفحات TEL (AP-TEL-01): شناسه صفحات، کلیدهای Query و رنگ وضعیت اتاق مجازی، جلسه و نوع ارتباط.
import type {
  TelConnectionMode,
  TelVirtualRoomStatus,
  TelVirtualSessionStatus,
} from '@phoenix/api-client';
import { StatusChip, type StatusTone } from '@phoenix/ui';

/** پنل ویدئو در میز کار پزشک (US-TEL-020 تا 022، 030). */
export const COMP_VIDEO_PANEL = 'COMP-VIDEO-PANEL';
/** پایش اتاق‌های انتظار (US-TEL-013، 050). */
export const SCR_STAFF_980 = 'SCR-STAFF-980';
/** تنظیمات ویزیت آنلاین (US-TEL-001). */
export const SCR_STAFF_982 = 'SCR-STAFF-982';

export const telKeys = {
  all: (tenantId?: string) => ['telehealth', tenantId] as const,
  settings: (tenantId?: string) => ['telehealth', tenantId, 'settings'] as const,
  waitingRoom: (tenantId: string | undefined, providerId: string) =>
    ['telehealth', tenantId, 'waiting-room', providerId] as const,
  roomByAppointment: (tenantId: string | undefined, appointmentId: string) =>
    ['telehealth', tenantId, 'room', appointmentId] as const,
  session: (tenantId: string | undefined, sessionId: string) =>
    ['telehealth', tenantId, 'session', sessionId] as const,
  chat: (tenantId: string | undefined, sessionId: string) =>
    ['telehealth', tenantId, 'chat', sessionId] as const,
};

/** عدد از قرارداد (int64 ممکن است رشته باشد). */
export function telNum(value: number | string | null | undefined): number {
  if (value === null || value === undefined) {
    return 0;
  }
  return typeof value === 'number' ? value : Number(value);
}

export function RoomStatusChip({ status }: { status: TelVirtualRoomStatus }) {
  const tone: StatusTone =
    status === 'InSession'
      ? 'in_service'
      : status === 'Waiting'
        ? 'pending'
        : status === 'Completed'
          ? 'done'
          : status === 'Cancelled'
            ? 'cancelled'
            : status === 'Expired'
              ? 'no_show'
              : 'confirmed';
  return (
    <span data-testid="tel-room-status" data-status={status}>
      <StatusChip tone={tone} labelKey={`tel:room_status.${status}`} />
    </span>
  );
}

export function SessionStatusChip({ status }: { status: TelVirtualSessionStatus }) {
  const tone: StatusTone = status === 'Active' ? 'in_service' : status === 'Ended' ? 'done' : 'no_show';
  return (
    <span data-testid="tel-session-status" data-status={status}>
      <StatusChip tone={tone} labelKey={`tel:session_status.${status}`} />
    </span>
  );
}

export function ModeChip({ mode }: { mode: TelConnectionMode }) {
  const tone: StatusTone = mode === 'Video' ? 'done' : mode === 'AudioOnly' ? 'pending' : 'inactive';
  return (
    <span data-testid="tel-mode" data-mode={mode}>
      <StatusChip tone={tone} labelKey={`tel:mode.${mode}`} />
    </span>
  );
}

/** مدت جلسه به دقیقه و ثانیه (فراداده جلسه؛ هیچ محتوای بالینی در این نمایش نیست). */
export function durationLabel(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return `${minutes}:${rest < 10 ? '0' : ''}${rest}`;
}
